import React from 'react';
import { ResponsiveBar } from '@nivo/bar';

const commonProps = {
  padding: 0.2,
  labelTextColor: 'inherit:darker(1.4)',
  labelSkipWidth: 16,
  labelSkipHeight: 16,
  margin: { top: 60, right: 110, bottom: 60, left: 80 },
  colors: ['#2eb85c', '#e55353']
};

interface RatingChartProps {
  data: any[];
  onClick: (rowData) => void;
  keys: string[];
  indexBy: string;
}

const DailyVolumeChart = (props: RatingChartProps) => {
  const { data, onClick, indexBy, keys } = props;

  return (
    <ResponsiveBar
      {...commonProps}
      keys={keys}
      indexBy={indexBy}
      data={data}
      animate={false}
      groupMode="grouped"
      onClick={onClick}
    />
  );
};

export default DailyVolumeChart;
